import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = $;
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

import libs from './lib/dependencies';
window.libs = libs;

let root = document.documentElement;


libs.AOS.init({
    duration: 1500 // values from 0 to 3000, with step 50ms
});

const observer = libs.lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

$(document).foundation();


$(window).on('load', function() {
    // page is fully loaded, including all files, objects and images
    'use strict';

    pageLoader();
    vh100();

    // $(".twentytwenty-container[data-orientation!='vertical']").twentytwenty({default_offset_pct: 0.7});
    // $(".twentytwenty-container[data-orientation='vertical']").twentytwenty({default_offset_pct: 0.3, orientation: 'vertical'});

    // Activate modal if present
    if(libs.Cookie.get('reveal-messsage')!="hide")
    {
        if($('#reveal-messsage').length > 0){
             $('#reveal-messsage').foundation('open');
         }

         $('#reveal-messsage[data-reveal]').on('closed.zf.reveal', function () {
            // var modal = $(this);
            libs.Cookie.set('reveal-messsage', 'hide', { expires: 1 });
          });
     }
});


// /* START DOCUMENT READY  */
// jQuery(function() {

//     // Call the resize event to display images
//     // in slideshow correctly (or they're collapsed)
//     if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
//         // For IE etc.
//         var evt = document.createEvent('UIEvents');
//         evt.initUIEvent('resize', true, false, window, 0);
//         window.dispatchEvent(evt);
//     } else {
//         // For modern browsers
//         window.dispatchEvent(new Event('resize'));
//     }
// });


/*----------------------------------------------
    P A G E L O A D E R
------------------------------------------------*/
function pageLoader(){
    if($('.loader-wrapper').length > 0){
        if($('.loader-wrapper').hasClass('loader-disabled')){
            $('.loader-wrapper').addClass('loaded');
        }else{
            if($('.section-portfolio').length > 0){
                setTimeout(function() {
                    $('.loader-wrapper').addClass('loaded');
                },500);
            }else{
                setTimeout(function() {
                    $('.loader-wrapper').addClass('loaded');
                },500);
            }
        }
    }
    // after page is loaded - activate lightgallery and resize the window
   //activateLightGallery()
}



/*------------------------------------------------------------
                    100 vh function
https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
------------------------------------------------------------*/

function vh100(){

    var innerHeight = window.innerHeight;

    // if(Foundation.MediaQuery.current == "small"){
    //     var verticalMenuHeight = $("#page-header").outerHeight();
    //     innerHeight = innerHeight - verticalMenuHeight;
    // }

    // Get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
   

    var headerHeight = $("#page-header").outerHeight();
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

    makeHeadroom()
}



/*------------------------------------------------------------
    R E S I Z E   F U N C T I O N
------------------------------------------------------------*/
// Throttled resize function
$(window).on('resize', Foundation.util.throttle(function(e){
    //console.log("Resized");

    // Recalculate vh
    vh100();

    // Do responsive stuff

    // Reload the drill-down
    // Foundation.reInit($('#main-nav .drilldown[data-drilldown]'));

    // hide the page navigation on medium-down

    // var myElement = document.querySelector(".sidebar.headroom");
    // var headroom  = new libs.Headroom(myElement);
    //
    // if(Foundation.MediaQuery.is('large down'))
    // {
    //     headroom.init();
    // }else{
    //     headroom.destroy();
    // }


}, 300));


/*----------------------------------------------
    H E A D E R  F U N C T I O N S 
------------------------------------------------*/
/**
* Get the header height. 
* @param  {Boolean} - withExtention - With or without px
* @param  {Integer} - addToValue - Add 
* @return {String} - The header height value
*/

function getHeaderHeight(withExtention = false, addToValue = 0){
    var headerHeight = document.documentElement.style.getPropertyValue('--header-height');
    headerHeight = headerHeight.replace("px", "");
    headerHeight = Math.ceil(headerHeight);

    if(addToValue != 0){
        headerHeight = headerHeight + addToValue;
    }

    if(withExtention){
        headerHeight = headerHeight + "px"
    }
    
    return headerHeight;
}


/*----------------------------
    H E A D R O O M
-----------------------------*/

function makeHeadroom(){
// - only on mobile (defined by class .is-mobile - which is set in master.cshtml)
// if(Foundation.MediaQuery.is('small only'))
// {
    //var myHeadroomElement = document.querySelector(".is-mobile .headroom");
    // var myHeadroomElement = document.querySelector(".headroom");
    var myHeadroomElement = document.querySelector("body");

    var offsetVal = document.documentElement.style.getPropertyValue('--header-height');
    offsetVal = offsetVal = '' ? 200 : offsetVal;
    offsetVal = offsetVal.replace("px", "");
    offsetVal = Math.ceil(offsetVal);

    // console.log("OffsetVal: " + offsetVal);

    var options = {
        // vertical offset in px before element is first unpinned
        offset : offsetVal
    }    
    var headroom  = new libs.Headroom(myHeadroomElement, options);
    headroom.init();
// }
}



/*--------------------------------
    M E N U   F U N C T I O N
---------------------------------*/
//Open submenu item from topNav
$('#top-nav a').on("click", function() {

    if($(this).data('open-nav'))
    {
        var levelName = $(this).data('open-nav');
        $('#off-canvas-full-screen').foundation('open');

        var mainNav = $('#main-nav ul.drilldown');
        //var findLevel = mainNav.find('li.packing');
        var findLevel = mainNav.find('li.' + levelName);
        mainNav.foundation('_show', findLevel);
    }
});


/*----------------------------------------------
    S C R O L L   T O   T O P
------------------------------------------------*/

$(function () {

    $(window).on("scroll", function () {

        // // fade in #back-top
        // if ($(this).scrollTop() > 100) {
        //     $('#back-top').fadeIn();
        // } else {
        //     $('#back-top').fadeOut();
        // }

        // fade out #scroll down-top
        if ($(this).scrollTop() > 100) {
            $('#scroll-down').fadeOut();
        } else {
            $('#scroll-down').fadeIn();
        }

    });

    // scroll body to 0px on click
    // $('#back-top').click(function (e) {
    //     e.preventDefault();
    //     window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    // });
});


/*----------------------------------------------
    T O P   N O T I F I C A T I O N
------------------------------------------------*/

$(function() { 
    //Attempt to get the element using document.getElementById
    var topNotification = document.getElementById("top-notification");

    //If it isn't "undefined" and it isn't "null", then it exists.
    if(typeof(topNotification) != 'undefined' && topNotification != null){
        showTopNotification();
    }



   $('#top-notification .close').on( 'click', function () {

       closeTopNotification();

       libs.Cookie.set('top-notification', 'hide', { expires: 1 });

   });
});


function getTopNotificationHeight(){
    var notificationHeight = $('#top-notification').outerHeight();
    return notificationHeight;
}


function showTopNotification(){

    if(libs.Cookie.get('top-notification')!="hide"){

        var notificationHeight = getTopNotificationHeight(); //$('#top-notification').outerHeight();

        setTimeout(function() {
            $('body').css('padding-top', notificationHeight).addClass('with-top-notification');

            document.documentElement.style.setProperty('--notification-height', `${notificationHeight}px`);
        
            // $('body.with-top-notfication.has-top-cover main section > .is-first.cover').css('padding-top', notificationHeight);
            // firstElementCoverPos();

            $('#top-notification').fadeIn('fast').animate({"top":"0"}, 300, function(){
                // $('body').addClass('with-top-notification');
                // notification i show - now animate badge
                $('#top-notification .badge').addClass("anim");
            });
        },800);
    }
}


function closeTopNotification(){
    $('body').css('padding-top', '').removeClass('with-top-notification');
    document.documentElement.style.removeProperty('--notification-height');
    $('#top-notification').addClass("closing").animate({"top":"-100px"}, 300, function(){
        $(this).hide();
        // $('body').removeClass('with-top-notification');
    });
}



/*----------------------------------------------
    O B J E C T F I T   F I X
------------------------------------------------*/

// https://github.com/fregante/object-fit-images
$(function () { libs.objectFitImages() })

// $(window).on('resize', Foundation.util.throttle(function(e){
// var images = {};
//
// $(window).on('load', Foundation.onImagesLoaded(images, function(e) {
//     console.log("Images Loaded!");
// })
// Foundation.onImagesLoaded($images, callback);



/*----------------------------------------------
    H A M B U R G E R   M E N U I C O N
------------------------------------------------*/

    // // Look for .hamburger
    // var hamburger = document.querySelector(".hamburger");
    // // On click
    // hamburger.addEventListener("click", function() {
    //     // Toggle class "is-active"
    //     hamburger.classList.toggle("is-active");
    //     // Do something else, like open/close menu
    // });

    // var $hamburger = $(".hamburger");
    // $hamburger.on("click", function(e) {
    //   $hamburger.toggleClass("is-active");
    //   // Do something else, like open/close menu
    // });

 /*----------------------------------------------
    L I G H T G A L L E R Y
 ------------------------------------------------*/

//  var LightGallery = require('lightgallery');
//  var LightGalleryVideo = require('lg-video');
//  var LightGalleryZoom = require('lg-zoom');
//  // var LightGalleryThumbnail = require('lg-thumbnail');
//  var LightGalleryFullscreen = require('lg-fullscreen');

//  $('.video-gallery').lightGallery({
//      // Videos
//      youtubePlayerParams: {
//          modestbranding: 1,
//          showinfo: 0,
//          controls: 1,
//          rel: 0
//      },
//      vimeoPlayerParams: {
//          autoplay : false,
//          byline : 0,
//          portrait : 0,
//          color : 'F08210'
//      },
//      //Video Thumbnails
//      loadYoutubeThumbnail: true,
//      youtubeThumbSize: 'default',
//      loadVimeoThumbnail: true,
//      vimeoThumbSize: 'thumbnail_large',
//  });

//  // Google map
//  $('#google-map').lightGallery({
//      selector: 'this',
//      iframeMaxWidth: '80%'
//  });



 


// $.each(dfvideo, function(index, value){

//     var $dfv = $('#play-'+value.videoId);

//     $dfv.on('click', function () {
//         // console.log("videobtn clicked 2");
//         playPause(value.videoId);
//         $(this).fadeOut('fast');
//     });
// });

// function playPause(videoid) {
//     var theVideo = document.getElementById(videoid);

//     if (theVideo.paused){
//         theVideo.play();
//     }else{
//         theVideo.pause();
//     }
// }



/*----------------------------------------------
        N O T I F I C A T I O N (pop-up)
------------------------------------------------*/

$(function(){

    if(libs.Cookie.get('notification')!="hide"){
        if(Foundation.MediaQuery.current == "small"){
            //$('#notification').fadeIn('slow');
        }else{
            $('#notification').fadeIn('fast').delay( 800 ).animate({"left":"0"}, "slow", function(){
                // notification i show - now animate badge
                $('#notification .badge').addClass("anim");
            });
        }
    }

    $('#notification .close').on( 'click', function () {

        if(Foundation.MediaQuery.current == "small"){
            //$('#notification').addClass("closing").fadeOut('slow');
        }else{
            $('#notification').addClass("closing").animate({"left":"-500px"}, "slow", function(){
                $(this).hide();
            });
        }

        libs.Cookie.set('notification', 'hide', { expires: 1 });

    });

});



/*----------------------------------------------
              G O O G L E   M A P S
------------------------------------------------*/

function initMap(){

    $('.google-maps').each(function(index, value) {

        var MapsId = $('div:first-of-type',this).attr('id');

        // Split from _ underscores
        var MapsElements = MapsId.split('_');
        // console.log(MapsElements[2]);

        var MapsElements = eval('map_elements_' + MapsElements[2]);
        // console.log(MapsElements);

        // Define bound variable
        // https://stackoverflow.com/questions/10634199/find-center-of-multiple-locations-in-google-maps
        var bound = new google.maps.LatLngBounds();

        var mapType = "";

        switch (MapsElements['mapType']) {
            case "HYBRID":
                mapType = google.maps.MapTypeId.HYBRID;
            break;
            case "SATELLITE":
                mapType = google.maps.MapTypeId.SATELLITE;
            break;
            case "TERRAIN":
                mapType = google.maps.MapTypeId.TERRAIN;
            break;
            default:
                mapType = google.maps.MapTypeId.ROADMAP;
        }

        var e={
            zoom:MapsElements['zoom'],
            center:new google.maps.LatLng(MapsElements['lat'],MapsElements['lng']),
            mapTypeId: mapType,
            styles:[{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"administrative.country","elementType":"labels.text","stylers":[{"visibility":"on"},{"color":"#ff0000"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#ff5d47"}]},{"featureType":"administrative.country","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#e0e0e0"}]},{"featureType":"landscape.natural.landcover","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#dadada"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#ebf7ff"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]}]
        },
        a=document.getElementById(MapsId),
        map=new google.maps.Map(a,e),
        infowindow=new google.maps.InfoWindow();

        // new google.maps.Marker({
        //     position:new google.maps.LatLng(MapsElements.lat,MapsElements.lng),
        //     map:s
        // })

        var markerimage1 = {
          url: '/assets/img/GoogleMaps/png/icon-mapmarker-full--blue.png',
          //url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
          // This marker is 35 pixels wide by 50 pixels high.
          size: new google.maps.Size(22, 40),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0)
          // The anchor for this image is the base
          //,anchor: new google.maps.Point(25, 50)
        };

        var markerimage2 = {
            url: '/assets/img/GoogleMaps/png/icon-mapmarker-full--orange.png',
            //url: '/files/Templates/Designs/vardefritidscenter21/assets/img/GoogleMaps/png/icon-mapmarker__turkis.png', //https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
          //url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
          // This marker is 35 pixels wide by 50 pixels high.
          size: new google.maps.Size(22, 40),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0)
          // The anchor for this image is the base
         // ,anchor: new google.maps.Point(25, 50)
        };

        var markerimage3 = {
            url: '/assets/img/GoogleMaps/png/icon-mapmarker-full--rose.png',
            //url: '/files/Templates/Designs/vardefritidscenter21/assets/img/GoogleMaps/png/icon-mapmarker__turkis.png', //https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
          //url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
          // This marker is 35 pixels wide by 50 pixels high.
          size: new google.maps.Size(22, 40),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0)
          // The anchor for this image is the base
         // ,anchor: new google.maps.Point(25, 50)
        };


        // Loop over markers, set in Paragraph/GoogleMaps.cshtml
        for (var i = 0; i < MapsElements['markers'].length; i++) {
          var markerInfo = MapsElements['markers'][i];

          // define markerIcon
          var markerIcon = null;

          if(markerInfo[3] == 'special'){
              markerIcon = markerimage1;
          }else if(markerInfo[3] == 'agent'){
              markerIcon = markerimage2;
          }

         // var markerIcon = markerInfo[3] == 'special' ? markerimage : null;

          var marker = new google.maps.Marker({
            position: {lat: markerInfo[1], lng: markerInfo[2]},
            map: map,
            icon: markerIcon,
            animation: google.maps.Animation.DROP,
            title: markerInfo[0],
            zIndex: markerInfo[4]
          });

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infowindow.setContent(MapsElements['markers'][i][5]);
                    infowindow.setOptions({maxWidth: 300});
                    infowindow.open(map, marker);
                }
            }) (marker, i));

          bound.extend( new google.maps.LatLng(markerInfo[1], markerInfo[2]) );
        }

        // Only make bounds if there more than one marker
        if(MapsElements['markers'].length > 1){
            map.fitBounds(bound);

            var zoomChangeBoundsListener =
                google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
                    if ( this.getZoom() ){   // or set a minimum
                        this.setZoom(MapsElements['zoom']);  // set zoom here
                    }
            });

            setTimeout(function(){google.maps.event.removeListener(zoomChangeBoundsListener)}, 2000);
        }

    });
}
// add initMap to global scope
window.initMap = initMap;



/*----------------------------------------------
                        MISC
------------------------------------------------*/


// Toggle body class, when menu is opened / closed
$(document).on('opened.zf.offCanvas close.zf.offCanvas', '#offcanvas-full-screen[data-off-canvas]', function () {
    $('body').toggleClass('off-canvas-is-open');
});


// var scrolledCallback = function () {
//     // if(Foundation.MediaQuery.current == "small"){
//     //     if ($(window).scrollTop() > 10) {
//     //         closeTopNotification()
//     //     }else if($(window).scrollTop() == 0){
//     //         showTopNotification()
//     //     }
//     // }
// };
// window.addEventListener('scroll', Foundation.util.throttle(scrolledCallback, 500, { leading: true, trailing: true}));

  // core version + navigation, pagination modules:
    import SwiperCore, { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/core';
  

  // configure Swiper to use modules
  SwiperCore.use([EffectFade, Navigation, Pagination, Autoplay]);

// init Swiper:
  const swiper = new libs.Swiper('.swiper-container', {
    // Optional parameters
    // direction: 'vertical',
    loop: true,
    speed: 400,
    effect: "fade",
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
  
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });


  const topSwiper = new libs.Swiper('.swiper-top', {
    // Optional parameters
    // direction: 'vertical',
    loop: true,
    speed: 400,
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
  
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });


// const testimonialsSwiper = new libs.Swiper('.testimonials-container', {
//     // Optional parameters
//     loop: true,
//     // slidesPerView: 3,
//     // spaceBetween: 60,
  
//     // If we need pagination
//     // pagination: {
//     //   el: '.swiper-pagination',
//     // },
  
//     // Navigation arrows
//     navigation: {
//       nextEl: '.swiper-button-next.testimoniali',
//       prevEl: '.swiper-button-prev.testimoniali',
//     },

//     breakpoints: {
//         "@0.00": {
//           slidesPerView: 1,
//           spaceBetween: 60,
//         },
//         "@0.75": {
//           slidesPerView: 2,
//           spaceBetween: 60,
//         },
//         "@1.00": {
//           slidesPerView: 3,
//           spaceBetween: 120,
//         },
//         // "@1.50": {
//         //   slidesPerView: 4,
//         //   spaceBetween: 50,
//         // },
//     }
  
//     // And if we need scrollbar
//     // scrollbar: {
//     //   el: '.swiper-scrollbar',
//     // },
//   });

  // init Swiper:
const logosSwiper = new libs.Swiper('.logos-container', {
    // Optional parameters
    loop: true,
    speed: 400,
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    // slidesPerView: 3,
    // spaceBetween: 60
  
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    // },
  
    // Navigation arrows
    // navigation: {
    //   nextEl: '.swiper-button-next.logoi',
    //   prevEl: '.swiper-button-prev.logoi',
    // },

    breakpoints: {
        "@0.00": {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        "@1.00": {
          slidesPerView: 5,
          spaceBetween: 30,
        },
        // "@1.50": {
        //   slidesPerView: 4,
        //   spaceBetween: 50,
        // },
    }
  
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });

  const partnersSwiper = new libs.Swiper('.partners-container', {
    // Optional parameters
    loop: true,
    // slidesPerView: 3,
    // spaceBetween: 60,
  
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    // },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next.partneri',
      prevEl: '.swiper-button-prev.partneri',
    },

    breakpoints: {
        "@0.00": {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        "@1.25": {
          slidesPerView: 3,
          spaceBetween: 60,
        }
    }
  
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });

  



/*----------------------------------------------
            P R O C E S S  L I N K S
------------------------------------------------*/

$('a').on( 'click', function(e) {

    var videoObj = parseVideo(this.href);

    //console.log($(this).attr('href') + " VideoObj.: " + videoObj.type);
    if(this.href != "") 
    { 

        
        e.preventDefault();

        if(videoObj.type == 'vimeo'){ //this.href.includes('vimeo')

            // Check if statistics Cookies is accepted from Cookiebot
            if (Cookiebot.consent.statistics)
            {
                CreateRevealAndVideo(this.href)
            }else{
                window.location = this.href;
            }
        }
        else if(videoObj.type == 'youtube'){ //this.href.includes('youtube')

            // Check if marketing Cookies is accepted from Cookiebot
            if (Cookiebot.consent.marketing)
            {
                CreateRevealAndVideo(this.href)
            }else{
                window.location = this.href;
            }

        }
        else if(videoObj.type == 'local'){ //this.href.includes('.mp4')
            CreateRevealAndVideo(this.href)
        }
        //else if(/^#[^ ]+$/.test(this.href)){
        else if(this.href.includes("#")){
        // It's an anchor - scroll to position
        
            var parts = this.href.split('#');
            if (parts.length > 1) {
                //console.log(parts.pop());
                Foundation.SmoothScroll.scrollToLoc('#'+parts.pop(), {
                    animationEasing: 'swing',
                    animationDuration: 1200,
                    threshold: 50,
                    offset: getHeaderHeight(false, 20)
                });                
            }
        }
        // else if(this.href.includes("/downloads")){
        //     $('#download-pop-up').foundation('open');
        // }
        else{
            //check if element has _blank
            if (!this.hasAttribute("target"))
            {
                window.location = this.href;
            }else{
                var win = window.open(this.href, '_blank');
                win.focus();
            }
        }
    }
    
});



function CreateRevealAndVideo(url){
    
    createReveal('large');
    $('#dynamic-reveal').foundation('open');
    addVideoToReveal(url);
}

function addVideoToReveal(url){
    
    $('<div/>', {
        "class": 'responsive-embed widescreen',
        html:  createVideo(url, "100%"),
    }).appendTo('#dynamic-reveal');
}


function createVideo (url, width, height) {
    // Returns an iframe of the video with the specified URL.
    var videoObj = parseVideo(url);

    if(videoObj.type == 'youtube' || videoObj.type == 'vimeo'){
        var $element = $('<iframe>', { width: width, height: height });
        $element.attr('frameborder', 0);
        $element.attr('allowfullscreen', true);
    }
   
    if (videoObj.type == 'youtube') {
        $element.attr('src', '//www.youtube.com/embed/' + videoObj.id + "?autoplay=1&playsinline=1&modestbranding=1&rel=0");//&mute=1
//<iframe id="ytplayer" type="text/html" width="720" height="405"
//src="https://www.youtube.com/embed/xnmr1KhxNgs?autoplay=1&hl=da&modestbranding=1&playsinline=1"
//frameborder="0" allowfullscreen>
    } else if (videoObj.type == 'vimeo') {
        $element.attr('src', '//player.vimeo.com/video/' + videoObj.id + "?autoplay=1&playsinline=1&title=0&byline=0&badge=0&rel=0");
        $element.attr('allow','autoplay; fullscreen');
        $element.attr('allowfullscreen', 'true');
    } else if (videoObj.type == 'local') {
        var $element = $('<video/>', { width: width, height: height });
        $element.attr('src', videoObj.id);
        $element.attr({
            controls: '',
            autoplay: '1',
            fullscreen: '',
            playsinline: ''
        });
    }

    return $element;
}


function parseVideo (url) {
    // Edited version of https://gist.github.com/yangshun/9892961 - have included .mp4
    // - Supported YouTube URL formats:
    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
    //   - http://youtu.be/My2FRPA3Gf8
    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
    // - Supported Vimeo URL formats:
    //   - http://vimeo.com/25451551
    //   - http://player.vimeo.com/video/25451551
    // - Also supports relative URLs:
    //   - //player.vimeo.com/video/25451551

    var type = '';
    var id = '';
    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

    if (RegExp.$3.indexOf('youtu') > -1) {
        type = 'youtube';
        id = RegExp.$6;
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
        type = 'vimeo';
        id = RegExp.$6;
    } else if(url.includes('.mp4')){
        type = 'local';
        id = url;
    }

    return {
        type: type,
        id: id
    };
}

function createReveal(size){
    var dynamicReveal = document.getElementById("dynamic-reveal");

    //If it isn't "undefined" and it isn't "null", then it exists.
    if(typeof(dynamicReveal) == 'undefined' || dynamicReveal == null){
        
        //var closeButton = '<button class="close-button" data-close aria-label="Luk" type="button"><span aria-hidden="true">&times;</span></button>';
        
        $('<div/>', {
            id: 'dynamic-reveal',
            "class": 'reveal ' + size,
            html: '',//closeButton,
            'data-reveal': 'true',
            'data-animation-in': 'fade-in fast',
            'data-v-offset': 'inherit',//getHeaderHeight(false, 20), // '0' // 0 hvis modal skal være helt i top
            'style': 'padding:0;'
        }).appendTo('body');

        $('#dynamic-reveal').foundation();

        
        /* 
        ** Add close button
        */
        // define container to which the close button should be added to
        var $container = Foundation.MediaQuery.only('small') ? $('#dynamic-reveal') : $('#dynamic-reveal').parent();
         
        $('<div/>', {
            "class": 'close-button',
            html: '<span aria-hidden="true">&times;</span>',//closeButton,
            'aria-label': 'Close alert',
            'type': 'button',
            'data-close' : ''
        }).appendTo($container);

        // Activate "on close" event
        $('#dynamic-reveal[data-reveal]').on('closed.zf.reveal', function () {
            $(this).foundation('_destroy').remove();
        });
    }
}



function addScript(url) {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    var x = document.getElementsByTagName('body')[0];
    x.appendChild(s);
}

function addStylesheet(url) {
    var s = document.createElement('link');
    s.type = 'text/css';
    s.async = true;
    s.rel = 'stylesheet';
    s.href = url;
    var x = document.getElementsByTagName('body')[0];
    x.appendChild(s);
}


    //   // 2. This code loads the IFrame Player API code asynchronously.
    //   var tag = document.createElement('script');

    //   tag.src = "https://www.youtube.com/iframe_api";
    //   var firstScriptTag = document.getElementsByTagName('script')[0];
    //   firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    //   // 3. This function creates an <iframe> (and YouTube player)
    //   //    after the API code downloads.
    //   var player;
    //   function onYouTubeIframeAPIReady() {
    //     player = new YT.Player('player', {
    //       height: '390',
    //       width: '640',
    //       videoId: 'M7lc1UVf-VE',
    //       playerVars: {
    //         'playsinline': 1
    //       },
    //       events: {
    //         'onReady': onPlayerReady,
    //         'onStateChange': onPlayerStateChange
    //       }
    //     });
    //   }

    //   // 4. The API will call this function when the video player is ready.
    //   function onPlayerReady(event) {
    //     event.target.playVideo();
    //   }



    // $('#send-mail').on('click', function(){
    //     $("#contact-form").foundation('validateForm');
    
    //     //console.log($("#step-1").find(".is-invalid-label").length )
    
    //     // Check if any errors
    //     if($("#contact-form").find(".is-invalid-label").length == 0 && $("#contact-form").find(".is-invalid-input").length == 0)
    //     {
    //         //No errors
    //         $(this).attr("disabled", "true");
    //         sendMail();
    //     }
    // });

    $('#send-mail').on('click', function(){
        console.log("Send-mail clicked");
        $("#contact-form").foundation('validateForm');
    
        //console.log($("#step-1").find(".is-invalid-label").length )
    
        // Check if any errors
        if($("#contact-form").find(".is-invalid-label").length == 0 && $("#contact-form").find(".is-invalid-input").length == 0)
        {
            //No errors - submit form
            console.log("Submitting");
            $("#contact-form form").submit();

        }
    });

    
    // $('#accept-privacy').on('change', function(){
    //     if($(this).is(':checked')){
    //         $('#send-mail').removeAttr("disabled");
    //         $(this).val('accepted')
    //     }else{
    //         $('#send-mail').attr("disabled", "true");
    //         $(this).val('denied')
    //     }
    // });
    
    // // Show 'navigate away from page'-alert promt
    // $('#firstName').on('focus',function(){
    //     window.onbeforeunload = function (e) {
    //         return "Er du sikker på at du vil navigere væk fra denne side? - Eventuelle indtastede værdier vil blive slettet.";
    //     };
    // });
    
    // $(document).on('invalid.zf.abide', function () {
    //     console.log("Theres errors");
    // });
    
    // $(document).on('forminvalid.zf.abide', function (e) {
    //     $('#error-msg').fadeIn();
    //     console.log("Form is invalid");
    //     console.log(e);
    // });
    
    // $(document).on('formvalid.zf.abide', function (e) {
    //     $('#error-msg').fadeOut();
    // });
    

    
    // function sendMail() {
    //     // Show 'navigate away from page'-alert promt
    //     window.onbeforeunload = function (e) {
    //         return;
    //     };
    
    //     var datavar = 'firstName='+$("#firstName").val()+
    //     '&lastName='+$("#lastName").val()+
    //     '&email='+$("#email").val()+
    //     '&phone='+$("#phone").val()+
    //     '&accept-privacy='+$("#accept-privacy").val();
       
    //     //'&institution='+$("#institution").val()+
    //     //'&grade-level='+$("#grade-level").val()+
    //     //'&catering='+$("#catering").val()+
    //     //'&combi-catering='+$("#combi-catering").val()+
    //     //'&cabin4='+$("#cabin4").val()+
    //     //'&cabin8='+$("#cabin8").val()+
      
    //     //console.log("datavar: " + datavar);
    
    //     jQuery.ajax({
    //         url: "/send-mail/",
    //         data: datavar,
    //         type: "POST",
    //         // success:function(data){
    //         //     $("#ajaxResponseSuccess").html(data);
    //         // },
    //         success: function(data, textStatus, jqXHR){
    //            //console.log(textStatus + ": " + jqXHR.status);
    //            // do something with data
    //            //clearForm("#contact-modal");
    //            $('#final-message-modal').foundation('close');
    //             //    $("#form").fadeOut(300, function(){
    //             //        $(this).remove();
    //             //        $("#ajax-response").html(data).fadeIn(300);
    //             //    });
    
    //             window.location = "/tak-for-din-foresporgsel/";
    
    //            /* Send custom Event Code to GTM */
    //         //    window.dataLayer = window.dataLayer || [];
    //         //    window.dataLayer.push({
    //         //        'event': 'contactMailSent'
    //         //    });
    
    //            //console.log(data);
    //          },
    //          error: function(jqXHR, textStatus, errorThrown){
    //            console.log(textStatus + ": " + jqXHR.status + " " + errorThrown);
    // //               if(jqXHR.status == 404) {
    //                //console.log("Error");
    // //            }
    //             $("#ajax-error-response").html("<p>Der skete en fejl, prøv igen senere. <br> Hvis fejlen fortsætter så kopier ovenstående og send til os på <a href='mailto:mb@bjerrum-montage.dk'>mb@bjerrum-montage.com</a></p>").fadeIn(300);
    //          }
    //     });
    // }



/*******************
  ---- Count Up ----
*******************/
// https://codepen.io/hi-im-si/pen/uhxFn

$('.counter-container').each(function() {
    const duration = $(this).data('counter-duration');
    var AOSid = $(this).data('aos-id');

    // on AOS - fade-in - count up
    document.addEventListener('aos:in:' + AOSid, ({ detail }) => {

        //console.log("fired " + AOSid);

        $('.counter').each(function() {

            var $this = $('[data-count]',this),
            countTo = $this.data('count');


            $({ countNum: $this.text()}).animate({
                countNum: countTo
            },
            {
                duration: duration,
                easing:'swing',
                step: function() {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function() {
                    $this.text(this.countNum);
                    //alert('finished');
                }

            });

        });

    });

});


// document.addEventListener("mousemove", parallax);
// function parallax(event) {
//     //console.log('moved');
//   //this.querySelectorAll(".parallax-wrap span").forEach((shift) => {
//     this.querySelectorAll(".parallax").forEach((shift) => {
//     const position = shift.getAttribute("value");
//     const x = (window.innerWidth - event.pageX * position) / 90;
//     const y = (window.innerHeight - event.pageY * position) / 90;

//     shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
//     //shift.style.top = `${x}px`;
//   });
// }

// root.addEventListener("mousemove", e => {
//     // root.style.setProperty('--mouse-x', e.clientX + "px");
//     // root.style.setProperty('--mouse-y', e.clientY + "px");

//     // In percents
//     let xPercent = parseInt(e.clientX / window.innerWidth * 100);//parseInt(e.pageX / window.innerWidth * 100);
//     let yPercent = parseInt(e.clientY / window.innerHeight * 100);//parseInt(e.pageY / window.innerHeight * 100);

    
//     setTimeout(function() {
//         root.style.setProperty('--mouse-x', xPercent + "%");
//         root.style.setProperty('--mouse-y', yPercent + "%");
//     },5000);
//     //console.log(xPercent);
// });




// ----------------
// -- SHUFFLE.JS --
// ----------------
//Attempt to get the element using document.getElementById
// var shuffleContainer = document.getElementById('case-list');

// //If it isn't "undefined" and it isn't "null", then it exists.
// if(typeof(shuffleContainer) != 'undefined' && shuffleContainer != null){

//     libs.imagesloaded( '#case-list', function() {
//         console.log('IMAGES loaded');

        
//         var Shuffle = libs.shuffle;
//         //var element = document.querySelector('#shuffle-container');
//         //var sizer = element.querySelector('.cell');
        
//         var shuffleInstance = new Shuffle(shuffleContainer, {
//             // itemSelector: '.activity',
//             // sizer: '.my-sizer-element'
//             itemSelector: '.case',
//             // sizer: '.shuffle-item-sizer'
//         });


//         function choosenSorting(button){
//             var list = $( '#case-sorting' );
//             var listItems = list.find('button.is-active');
            
//             listItems.removeClass( 'is-active' ).addClass( 'hollow' );
//             $('#' + button).removeClass( 'hollow' ).addClass('is-active ');
//         }

//         $('#btn-all').on('click', function () {
//             shuffleInstance.filter('all');
//             choosenSorting($(this).attr('id'));
//         });
        
//         $('#btn-cases').on('click', function () {
//             shuffleInstance.filter('case');
//             choosenSorting($(this).attr('id'));
//         });
        
//         $('#btn-articles').on('click', function () {
//             shuffleInstance.filter('article');
//             choosenSorting($(this).attr('id'));
//         });
        
//         $('#btn-strategy-and-leadership').on('click', function () {
//             shuffleInstance.filter('strategy+%26+leadership');
//             choosenSorting($(this).attr('id'));
//         });
        
//         $('#btn-project-and-management').on('click', function () {
//             shuffleInstance.filter('project+management');
//             choosenSorting($(this).attr('id'));
//         });
        
//         $('#btn-innovation').on('click', function () {
//             shuffleInstance.filter('innovation');
//             choosenSorting($(this).attr('id'));
//         });
        
//         $('#btn-lean-and-agile').on('click', function () {
//             shuffleInstance.filter('lean+%26+agile');
//             choosenSorting($(this).attr('id'));
//         });
//     });
// }


// var shuffleInstance = new Shuffle(element, {
//     sizer: sizer
//     //itemSelector: '.picture-item',
//     //sizer: sizer // could also be a selector: '.my-sizer-element'
// });


// Check for rise / lower
$('div[class*="-lower-"], div[class*="-rise-"]').each(function(index, value) 
{

    //console.log($(this));
    let getWholeClass =  $(this).attr('class');
    //console.log(getWholeClass);
    
    //console.log(getWholeClass.split('-lower-')[1]);

    //$(this).parentsUntil("section").parent().addClass("thisone");
    //$(this).parentsUntil("section").parent().css({"padding-bottom":"100px"});
    // $(this).closest("section").css({"padding-bottom":"100px"});
    
    var matchLower = getWholeClass.match(/[^ ]*lower[^ ]*/);
    var matchRise = getWholeClass.match(/[^ ]*rise[^ ]*/);
    console.log(matchLower);
    console.log(matchRise);
    // Get id from nearest section
    let sectionId = $(this).closest("section").attr('id');
   
    //lower-.*?\s


    var style = document.createElement('style');
    // style.textContent = `
    // #${sectionId} {

    //   padding-bottom: 100px;
    // }`;
  
//   //document.head.appendChild(style);
//   var x = document.getElementsByTagName('body')[0];
//   x.appendChild(style);


});


if($('#section-1').hasClass('cover')){
    console.log('#section-1 has class .cover');
    $('html').addClass('with-top-media');
}





// window.onload = function () {

//     var parallaxElem = document.getElementById("l1");

//     //If it isn't "undefined" and it isn't "null", then it exists.
//     if(typeof(parallaxElem) != 'undefined' && parallaxElem != null){

//         var parallaxBox = document.getElementById ( 'top' );
//         var c1left = document.getElementById ( 'l1' ).offsetLeft,
//         c1top = document.getElementById ( 'l1' ).offsetTop;
//         // c2left = document.getElementById ( 'l2' ).offsetLeft,
//         // c2top = document.getElementById ( 'l2' ).offsetTop,
//         // c3left = document.getElementById ( 'l3' ).offsetLeft,
//         // c3top = document.getElementById ( 'l3' ).offsetTop;
//         // c4left = document.getElementById ( 'l4' ).offsetLeft,
//         // c4top = document.getElementById ( 'l4' ).offsetTop;
        
//         parallaxBox.onmousemove = function ( event ) {
//             event = event || window.event;
//             var x = event.clientX - parallaxBox.offsetLeft,
//             y = event.clientY - parallaxBox.offsetTop;
            
//             mouseParallax ( 'l1', c1left, c1top, x, y, 15 );
//             // mouseParallax ( 'l2', c2left, c2top, x, y, 30 );
//             // mouseParallax ( 'l3', c3left, c3top, x, y, 65 );
//             // mouseParallax ( 'l4', c4left, c4top, x, y, 65 );
//         }
//     }
// }

// function mouseParallax ( id, left, top, mouseX, mouseY, speed ) {
//     var obj = document.getElementById ( id );
//     var parentObj = obj.parentNode,
//     containerWidth = parseInt( parentObj.offsetWidth ),
//     containerHeight = parseInt( parentObj.offsetHeight );
//     obj.style.left = left - ( ( ( mouseX - ( parseInt( obj.offsetWidth ) / 2 + left ) ) / containerWidth ) * speed ) + 'px';
//     obj.style.top = top - ( ( ( mouseY - ( parseInt( obj.offsetHeight ) / 2 + top ) ) / containerHeight ) * speed ) + 'px';
// }


if(libs.Cookie.get('contact-bubble')!="hide"){
    

    if($('#contact-bubble').length > 0){
        setTimeout(function() {
            $('#contact-bubble').addClass('loaded');
            setTimeout(function() {
                $('#contact-bubble>div>div, #contact-bubble span.close').fadeIn();
            },2000);        
        },5000);
    }
    
    // Contact bubble
    $('#contact-bubble .close').on("click", function() {
        //$('#contact-bubble .speech-bubble, #contact-bubble .close').fadeOut()//.foundation('open');
        // $('#contact-bubble').fadeOut('fast', function(){
        //         libs.Cookie.set('contact-bubble', 'hide', { expires: 1 });
        // });
        $('#contact-bubble>div>div, #contact-bubble span.close').fadeOut('fast', function(){
            //         libs.Cookie.set('contact-bubble', 'hide', { expires: 1 });
            setTimeout(function() {
                $('#contact-bubble').removeClass('loaded');
            });
        });
    });
}
